import React from 'react';

import {BarChartContentProps, BarChartType} from './BarChartTypes';
import GroupedBarChartContent from './GroupedBarChartContent';
import StackedBarChartContent from './StackedBarChartContent';

export const BAR_CHART_TYPE_TO_CONTENT_COMPONENT: {[key in BarChartType]: React.FC<BarChartContentProps>} = {
  // Do not do `[BarChartType.GROUPED]: GroupedBarChartContents`, as the imports may be uninitialized.
  [BarChartType.GROUPED]: (props) => <GroupedBarChartContent {...props} />,
  [BarChartType.STACKED]: (props) => <StackedBarChartContent {...props} />,
};

export const BAR_PADDING_BETWEEN_BARS = 0.1;
export const BAR_PADDING_BETWEEN_GROUPS = 0.2;
